<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px"> {{ i18nValues['stockMovementHistory'] || 'Histórico de Movimientos de Stock' }}</h4>
      </div>

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form v-loading="loading != 0">
          <div class="main-content-wrapper">
            <!-- Left Section: Filters and Table -->
            <div class="left-section">
              <div class="filters-wrapper">
                <div class="filters-row">
                  <!-- Search Bar -->
                  <el-form-item v-if="false" label="Buscar" prop="search">
                    <el-input
                      v-model="filter.search"
                      placeholder="Buscar: Lote, pallet, etiqueta, transportista..."
                      prefix-icon="fas fa-search"
                    ></el-input>
                  </el-form-item>

                  <!-- Tipo de Operación -->
                  <el-form-item v-if="false" label="Tipo de Operación" prop="operationType">
                    <el-select
                      v-model="filter.operationType"
                      placeholder="Todas"
                      clearable
                    >
                      <el-option label="Todas" :value="null"></el-option>
                      <el-option label="Ingreso" value="ingreso"></el-option>
                      <el-option label="Salida" value="salida"></el-option>
                      <el-option label="Excedente" value="excedente"></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- Estado del Stock -->
                  <el-form-item v-if="false" label="Estado del Stock" prop="stockStatus">
                    <el-select
                      v-model="filter.stockStatus"
                      placeholder="Todos"
                      clearable
                    >
                      <el-option label="Todos" :value="null"></el-option>
                      <el-option label="Disponible" value="disponible"></el-option>
                      <el-option label="Cargado" value="cargado"></el-option>
                      <el-option label="En Tránsito" value="en_transito"></el-option>
                      <el-option label="Despachado" value="despachado"></el-option>
                      <el-option label="Excedente" value="excedente"></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- Planta Origen Filter -->
                  <el-form-item :label="i18nValues['originFieldSite'] || 'Planta Origen'" prop="originFieldSiteId">
                    <el-select
                      v-model="filter.originFieldSiteId"
                      :placeholder="i18nValues['originFieldSite']"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="fs in fieldSitesList"
                        :key="fs.id"
                        :label="fs.name"
                        :value="fs.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- Planta Destino Filter -->
                  <el-form-item :label="i18nValues['destinationFieldSite'] || 'Planta Destino'" prop="destinationFieldSiteId">
                    <el-select
                      v-model="filter.destinationFieldSiteId"
                      :placeholder="i18nValues['destinationFieldSite']"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="fs in fieldSitesList"
                        :key="fs.id"
                        :label="fs.name"
                        :value="fs.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- Brand / Variedad (Product) Filter -->
                  <el-form-item label="Brand" prop="productId">
                    <el-select
                      v-model="filter.productId"
                      filterable
                      clearable
                      :placeholder="i18nValues['brand-variety'] || 'Brand - Variedad'"
                    >
                      <el-option
                        v-for="product in ProductList"
                        :key="product.id"
                        :label="product.brand + ' - ' + product.name"
                        :value="product.id"
                      >
                        <span
                          v-html="
                            `<strong>${product.brand}</strong> - ${product.name}`
                          "
                        ></span>
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <!-- Loading Order ID Filter -->
                  <el-form-item :label="i18nValues['order'] || 'Orden de Carga'" prop="loadingOrderId">
                    <el-input
                      v-model.number="filter.loadingOrderId"
                      :placeholder="i18nValues['order'] || i18nValues['loadingOrderId'] || 'ID Orden'"
                      type="number"
                      min="1"
                      clearable
                      @keypress.native="onlyNumbers"
                    ></el-input>
                  </el-form-item>

                  <!-- Fecha Desde -->
                  <el-form-item :label="i18nValues['from'] || 'Desde'" prop="dateSince">
                    <div class="input-group">
                      <el-date-picker 
                        v-model="filter.dateSince"
                        type="date" 
                        format="dd/MM/yyyy"
                        :clearable="true"
                        :placeholder="i18nValues['from'] || 'Desde'">
                      </el-date-picker>
                      <span class="input-group-addon primary el-input__suffix icon">
                        <span class="arrow"></span>
                        <i class="fa fa-calendar-alt"></i>
                      </span>                                
                    </div>
                  </el-form-item>

                  <!-- Fecha Hasta -->
                  <el-form-item :label="i18nValues['to'] || 'Hasta'" prop="dateUntil">
                    <div class="input-group">
                      <el-date-picker 
                        v-model="filter.dateUntil"
                        type="date" 
                        format="dd/MM/yyyy"
                        :clearable="true"
                        :placeholder="i18nValues['to'] || 'Hasta'">
                      </el-date-picker>
                      <span class="input-group-addon primary el-input__suffix icon">
                        <span class="arrow"></span>
                        <i class="fa fa-calendar-alt"></i>
                      </span>                                
                    </div>
                  </el-form-item>

                  <!-- Search Button -->
                  <el-button
                    @click="searchMovements()"
                    icon="fas fa-search"
                    size="small"
                    class="btn-primary"
                  >
                    {{ i18nValues['search'] || 'Buscar' }}
                  </el-button>

                  <!-- Export Button -->
                  <el-button
                    icon="fas fa-file-excel"
                    size="small"
                    class="btn-primary"
                    style="background-color: #67c23a; border-color: #67c23a;"
                    @click="exportData()"
                  >
                    {{ i18nValues['export'] || 'Exportar' }}
                  </el-button>
                </div>
              </div>

              <!-- Table -->
              <el-form-item prop="movements">
                <div class="full-width" style="margin:0 auto;padding:20px;">
                  <el-table
                    :data="movementsList"
                    class="table table-hover table-striped"
                    id="StockMovementTable"
                    align="center"
                    :empty-text="hasAttemptedLoad ? (i18nValues['noDataAvailable'] || 'No hay datos disponibles') : ''"
                    @sort-change="handleSortChange"
                  >
                    <!-- Fecha -->
                    <el-table-column
                      prop="fecha"
                      :label="i18nValues['date'] || i18nValues['fecha'] || 'Fecha'"
                      width="160"
                      align="center"
                      sortable
                    >
                      <template slot-scope="scope">
                        {{ formatDate(scope.row.fecha) }}
                      </template>
                    </el-table-column>

                    <!-- Operación -->
                    <el-table-column
                      prop="operacion"
                      :label="i18nValues['operation'] || i18nValues['operacion'] || 'Operación'"
                      width="160"
                      align="center"
                      sortable
                    ></el-table-column>

                    <!-- Tipo -->
                    <el-table-column
                      prop="type"
                      :label="i18nValues['type'] || i18nValues['tipo'] || 'Tipo'"
                      width="120"
                      align="center"
                      sortable
                    >
                      <template slot-scope="scope">
                        <el-tag
                          :type="scope.row.type === 'siloTrx' ? 'info' : scope.row.type === 'palletTrx' ? 'success' : scope.row.type === 'pallet' ? 'primary' : scope.row.type === 'loadingOrder' ? 'warning' : 'warning'"
                          size="small"
                          effect="plain"
                        >
                          {{ scope.row.type === 'siloTrx' ? (i18nValues['silo'] || 'Silo') : scope.row.type === 'palletTrx' ? (i18nValues['palletMovement'] || 'Mov. Pallet') : scope.row.type === 'pallet' ? (i18nValues['pallet'] || 'Pallet') : scope.row.type === 'loadingOrder' ? (i18nValues['order'] || 'Orden') : '-' }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <!-- Estado -->
                    <el-table-column
                      prop="estado"
                      :label="i18nValues['status'] || i18nValues['estado'] || 'Estado'"
                      width="120"
                      align="center"
                      sortable
                    >
                      <template slot-scope="scope">
                        <el-tag
                          :type="getStatusType(scope.row.estado) || undefined"
                          :style="!getStatusType(scope.row.estado) ? { backgroundColor: getStatusColor(scope.row.estado), borderColor: getStatusColor(scope.row.estado), color: 'white' } : {}"
                          size="small"
                          effect="dark"
                        >
                          {{ scope.row.estado }}
                        </el-tag>
                      </template>
                    </el-table-column>

                    <!-- Cultivo / Variedad -->
                    <el-table-column
                      prop="cultivoVariedad"
                      :label="i18nValues['cropVariety'] || i18nValues['cultivoVariedad'] || 'Cultivo / Variedad'"
                      width="180"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- Brand -->
                    <el-table-column
                      prop="brand"
                      :label="i18nValues['brand'] || 'Brand'"
                      width="100"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- Campo Origen -->
                    <el-table-column
                      prop="campoOrigen"
                      :label="i18nValues['originFieldSite'] || 'Campo Origen'"
                      width="180"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- Planta Destino -->
                    <el-table-column
                      prop="plantaDestino"
                      :label="i18nValues['destinationFieldSite'] || 'Planta Destino'"
                      width="180"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- Lote / Pallet -->
                    <el-table-column
                      :label="i18nValues['batchPallet'] || 'Lote / Pallet'"
                      width="200"
                      align="left"
                    >
                      <template slot-scope="scope">
                        {{ (i18nValues['batchLabel'] || 'Lote') }}: {{ scope.row.lote }}, {{ (i18nValues['palletLabel'] || 'Pallet') }}: {{ scope.row.pallet }}
                      </template>
                    </el-table-column>

                    <!-- Transportista -->
                    <el-table-column
                      prop="transportista"
                      :label="i18nValues['carrierCompany'] || i18nValues['transportista'] || 'Transportista'"
                      width="150"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- KG -->
                    <el-table-column
                      prop="kg"
                      :label="i18nValues['kg'] || 'KG'"
                      width="100"
                      align="right"
                      sortable
                    >
                      <template slot-scope="scope">
                        {{ formatNumber(scope.row.kg) }}
                      </template>
                    </el-table-column>

                    <!-- Acciones -->
                    <el-table-column
                      width="50"
                      align="right"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <el-button
                          class="text-info"
                          icon="fa fa-eye"
                          size="small"
                          :title="i18nValues['view'] || 'Ver detalles'"
                          @click="viewDetails(scope.row)"
                        ></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-if="serverTotalCount > 0" style="height: 15px"></div>
                  <div class="pagination-bar">
                    <el-pagination
                      v-if="serverTotalCount > pageSize"
                      @current-change="onPageChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="prev,pager,next"
                      :total="serverTotalCount"
                      :pager-count="5"
                    />
                    <div v-if="serverTotalCount > 0" class="results-info">
                      <p>
                        {{ i18nValues["showing"] || "Mostrando" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "de" }} {{ totalRecords }} {{ i18nValues["results"] || "resultados" }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>

            <!-- Right Section: Summary and Status -->
            <div class="right-section">
              <!-- Resumen -->
              <div class="summary-section">
                <h5 style="margin-bottom: 15px; font-weight: 600;">{{ i18nValues['summary'] || 'Resumen' }}</h5>
                <div class="summary-cards">
                  <div class="summary-card ingresos">
                    <div class="summary-number">{{ summary.ingresos }}</div>
                    <div class="summary-label">{{ i18nValues['incomes'] || i18nValues['ingresos'] || 'Ingresos' }}</div>
                  </div>
                  <div class="summary-card salidas">
                    <div class="summary-number">{{ summary.salidas }}</div>
                    <div class="summary-label">{{ i18nValues['exits'] || i18nValues['salidas'] || 'Salidas' }}</div>
                  </div>
                  <div v-if="false" class="summary-card excedentes">
                    <div class="summary-number">{{ summary.excedentes }}</div>
                    <div class="summary-label">{{ i18nValues['excess'] || i18nValues['excedentes'] || 'Excedentes' }}</div>
                  </div>
                  <div class="summary-card total-kg">
                    <div class="summary-number">{{ formatNumber(summary.totalKg) }}</div>
                    <div class="summary-label">{{ i18nValues['totalKg'] || i18nValues['kgTotal'] || 'KG Totales' }}</div>
                  </div>
                </div>
              </div>

              <!-- Estados del Stock -->
              <div v-if="false" class="status-section">
                <h5 style="margin-bottom: 15px; font-weight: 600;">Estados del Stock</h5>
                <div class="status-list">
                  <div
                    v-for="status in statusCounts"
                    :key="status.estado"
                    class="status-item"
                  >
                    <el-tag
                      :type="getStatusType(status.estado) || undefined"
                      :style="!getStatusType(status.estado) ? { backgroundColor: getStatusColor(status.estado), borderColor: getStatusColor(status.estado), color: 'white', marginRight: '10px' } : { marginRight: '10px' }"
                      size="small"
                      effect="dark"
                    >
                      {{ status.estado }}
                    </el-tag>
                    <span class="status-count">{{ status.count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>

    <!-- Stock Movement Detail Modal -->
    <StockMovementDetailModal
      :visible.sync="modalVisible"
      :movement="selectedMovement"
    />
  </div>
</template>

<script>
import { get } from "vuex-pathify";
import StockMovementDetailModal from "@/components/customer/invoicingmodule/modals/StockMovementDetailModal.vue";

export default {
  name: "StockMovementHistory",
  created() {
    this.loadFieldSitesList();
    this.retrieveProducts();
    // Data fetching is handled by the immediate watchers
  },

  components: {
    StockMovementDetailModal,
  },

  computed: {
    loading: get("stockHistory/loading"),
    globalCampaign: get("globalCampaign"),
    globalFieldSite: get("globalFieldSite"),
    i18nValues: get("i18nStore/valuesRetrieved"),
    selectedLanguage: get("i18nStore/selectedLanguage"),

    // Pagination helpers
    currentPage() {
      return this.initialPage || 1;
    },
    pageSize() {
      return 20;
    },
    totalRecords() {
      return this.serverTotalCount || 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    // Summary calculations
    summary() {
      let ingresos = 0;
      let salidas = 0;
      let excedentes = 0;
      
      const ingresosCamion = this.i18nValues['inTara'] || "Ingreso Camión";
      const consumoMP = this.i18nValues['mpConsumption'] || "Consumo MP";
      const recibido = this.i18nValues['received'] || "Recibido";
      const enviado = this.i18nValues['sent'] || "Enviado";
      const despacho = this.i18nValues['dispatch'] || "Despacho";
      
      this.movementsList.forEach(m => {
        // SiloTransactions
        if (m.type === "siloTrx") {
          if (m.operacion === ingresosCamion) {
            ingresos++;
          } else if (m.operacion === consumoMP) {
            salidas++;
          }
        }
        // PalletTransactions
        else if (m.type === "palletTrx") {
          if (m.operacion === recibido) {
            ingresos++;
          } else if (m.operacion === enviado) {
            salidas++;
          }
        }
        // Pallets
        else if (m.type === "pallet") {
          // Check original status from pallet
          const originalStatus = m.originalData && m.originalData.status;
          if (originalStatus === "dispatched" || originalStatus === "sent") {
            salidas++;
          } else {
            ingresos++;
          }
        }
        // LoadingOrders
        else if (m.type === "loadingOrder") {
          // Loading orders are always considered as outbound/salidas
          if (m.operacion === enviado || m.operacion === despacho) {
            salidas++;
          }
        }
        
        // Count excedentes if needed (for any type)
        if (m.operacion === "Excedente") {
          excedentes++;
        }
      });
      
      const totalKg = this.movementsList.reduce((sum, m) => sum + (m.kg || 0), 0);
      
      return {
        ingresos,
        salidas,
        excedentes,
        totalKg
      };
    },

    // Status counts
    statusCounts() {
      const statusMap = {};
      this.movementsList.forEach(m => {
        const estado = m.estado;
        statusMap[estado] = (statusMap[estado] || 0) + 1;
      });

      return Object.keys(statusMap).map(estado => ({
        estado,
        count: statusMap[estado]
      })).sort((a, b) => {
        const order = ["Disponible", "Abierto", "Para Despacho", "Cargado", "En Tránsito", "En Puerto", "Despachado", "Llegado a Destino", "Excedente"];
        return order.indexOf(a.estado) - order.indexOf(b.estado);
      });
    },
  },

  props: {
    componentsMap: {},
  },

  data() {
    const q = (this.$route && this.$route.query) || {};
    return {
      movementsList: [],
      allMovementsList: [],
      movementsSubList: [],
      initialPage: q.page ? Number(q.page) : 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      modalVisible: false,
      selectedMovement: null,
      fieldSitesList: [],
      ProductList: [],
      requestGeneration: 0,
      hasAttemptedLoad: false,
      serverTotalCount: 0,

      filter: {
        search: q.search || null,
        operationType: q.operationType || null,
        stockStatus: q.stockStatus || null,
        dateSince: q.dateSince ? new Date(q.dateSince) : null,
        dateUntil: q.dateUntil ? new Date(q.dateUntil) : null,
        originFieldSiteId: q.originFieldSiteId ? Number(q.originFieldSiteId) : null,
        destinationFieldSiteId: q.destinationFieldSiteId ? Number(q.destinationFieldSiteId) : null,
        productId: q.productId ? Number(q.productId) : null,
        loadingOrderId: q.loadingOrderId ? Number(q.loadingOrderId) : null,
      },
    };
  },

  watch: {
    globalFieldSite: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id === newVal.id) return;
        this.requestGeneration++;
        const isContextChange = !!(oldVal && oldVal.id);
        if (isContextChange) {
          this.filter.search = null;
          this.filter.operationType = null;
          this.filter.stockStatus = null;
          this.filter.dateSince = null;
          this.filter.dateUntil = null;
          this.filter.originFieldSiteId = null;
          this.filter.destinationFieldSiteId = null;
          this.filter.productId = null;
          this.filter.loadingOrderId = null;
          this.initialPage = 1;
          this.serverTotalCount = 0;
        }
        if (this.globalCampaign && this.globalCampaign.id) {
          this.loadStockHistory(!isContextChange);
        }
      },
    },
    globalCampaign: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id === newVal.id) return;
        this.requestGeneration++;
        if (this.globalFieldSite && this.globalFieldSite.id) {
          this.loadStockHistory(!(oldVal && oldVal.id));
        }
      },
    },
  },

  methods: {
    async loadStockHistory(preservePage) {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      if (!this.globalCampaign || !this.globalCampaign.id) return;

      this.hasAttemptedLoad = true;
      const gen = this.requestGeneration;

      try {
        const params = {
          fieldSiteId: this.globalFieldSite.id,
          campaignId: this.globalCampaign.id,
          page: preservePage ? this.currentPage : 1,
          pageSize: this.pageSize
        };
        if (this.filter.dateSince) {
          params.dateSince = new Date(this.filter.dateSince).getTime();
        }
        if (this.filter.dateUntil) {
          const dateUntil = new Date(this.filter.dateUntil);
          dateUntil.setHours(23, 59, 59, 999);
          params.dateUntil = dateUntil.getTime();
        }
        if (this.filter.originFieldSiteId) {
          params.originFieldSiteId = this.filter.originFieldSiteId;
        }
        if (this.filter.destinationFieldSiteId) {
          params.destinationFieldSiteId = this.filter.destinationFieldSiteId;
        }
        if (this.filter.productId) {
          params.productId = this.filter.productId;
        }
        if (this.filter.loadingOrderId) {
          params.loadingOrderId = this.filter.loadingOrderId;
        }

        const response = await this.$store.dispatch("stockHistory/retrieveStockHistory", params);
        if (gen !== this.requestGeneration) return; // stale response

        if (!response) {
          this.allMovementsList = [];
          this.movementsList = [];
          this.movementsSubList = [];
          this.serverTotalCount = 0;
          this.syncRouteFromState();
          return;
        }

        // Server returns totalCount across all pages
        this.serverTotalCount = response.totalCount || 0;
        this.transformStockHistoryResponse(response, preservePage);
      } catch (error) {
        if (gen !== this.requestGeneration) return;
        this.$message.error("Error al cargar el historial de movimientos de stock");
        this.movementsList = [];
        this.serverTotalCount = 0;
      }
    },

    async loadFieldSitesList() {
      try {
        const response = await this.$store.dispatch("fieldSite/retrieveFieldSites");
        this.fieldSitesList = response || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error loading fieldSites list:", error);
        this.fieldSitesList = [];
      }
    },

    retrieveProducts() {
      const productFilter = {};
      this.$store
        .dispatch("product/retrieveProducts", productFilter)
        .then((res) => {
          this.ProductList = res;
        });
    },

    transformStockHistoryResponse(response, preservePage) {
      const movements = [];

      // This function combines ALL stock movements into a unified list:
      // 1. siloTransactions - All silo transactions (entries to silos)
      // 2. palletTransactions - All pallet transactions (pallet movements)
      // 3. pallets - All pallets (individual pallets)
      // 4. loadingOrders - All loading/dispatch orders
      // All movements are combined, sorted by date, and displayed in a single table

      // Dev-only peek at the response structure to verify shape
      if (process && process.env && process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.log("[StockHistory] Full response:", response);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] siloTransactions array:", response && response.siloTransactions);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] first siloTrxWrapper:", response && response.siloTransactions && response.siloTransactions.length > 0 && response.siloTransactions[0]);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] first siloTrxWrapper.siloTrx:", response && response.siloTransactions && response.siloTransactions.length > 0 && response.siloTransactions[0] && response.siloTransactions[0].siloTrx);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] first siloTrxWrapper.relatedPallets:", response && response.siloTransactions && response.siloTransactions.length > 0 && response.siloTransactions[0] && response.siloTransactions[0].relatedPallets);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] palletTransactions array:", response && response.palletTransactions);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] first palletTrx:", response && response.palletTransactions && response.palletTransactions.length > 0 && response.palletTransactions[0]);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] pallets array:", response && response.pallets);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] first pallet:", response && response.pallets && response.pallets.length > 0 && response.pallets[0]);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] loadingOrders array:", response && response.loadingOrders);
        // eslint-disable-next-line no-console
        console.log("[StockHistory] first loadingOrder:", response && response.loadingOrders && response.loadingOrders.length > 0 && response.loadingOrders[0]);
      }

      // Transform siloTransactions (silo transactions - can be "Ingreso" or "Salida" based on operation)
      if (response.siloTransactions && Array.isArray(response.siloTransactions)) {
        response.siloTransactions.forEach(siloTrxWrapper => {
          // Extract the actual siloTrx from the wrapper
          const siloTrx = siloTrxWrapper.siloTrx || siloTrxWrapper;
          const relatedPallets = siloTrxWrapper.relatedPallets || [];
          
          // Log when we find related pallets
          if (relatedPallets.length > 0) {
            // eslint-disable-next-line no-console
            console.log(`[SiloTrx ${siloTrx.id}] COMPLETE WRAPPER WITH RELATED PALLETS:`, siloTrxWrapper);
            // eslint-disable-next-line no-console
            console.log(`  → siloTrx:`, siloTrx);
            // eslint-disable-next-line no-console
            console.log(`  → relatedPallets (${relatedPallets.length}):`, relatedPallets);
          }
          
          // Map operation to Spanish labels
          const operacion = this.mapSiloOperation(siloTrx.operation);
          // Calculate kg from quantity difference or use finalQuantity
          const kg = siloTrx.initialQuantity && siloTrx.finalQuantity 
            ? Math.abs(siloTrx.initialQuantity - siloTrx.finalQuantity)
            : (siloTrx.finalQuantity || siloTrx.initialQuantity || 0);
          
          const movement = {
            fecha: siloTrx.date || null,
            operacion: operacion,
            estado: this.mapSiloTrxStatus(siloTrx),
            cultivoVariedad: this.getCultivoVariedad(siloTrx.product),
            brand: this.getBrand(siloTrx.product),
            campoOrigen: (siloTrx.fieldSite && siloTrx.fieldSite.name) || this.getFieldName(siloTrx.field) || "-",
            plantaOrigen: this.getPlantName(siloTrx.silo ? [siloTrx.silo] : siloTrx.relatedSilos),
            plantaDestino: "-",
            lote: this.getLote(siloTrx.fieldLot),
            pallet: (relatedPallets.length > 0 && relatedPallets[0].id) ? relatedPallets[0].id : "-",
            etiqueta: (relatedPallets.length > 0 && relatedPallets[0].label && relatedPallets[0].label.id) ? relatedPallets[0].label.id : "-",
            transportista: (siloTrx.carrierCompany && (typeof siloTrx.carrierCompany === 'string' ? siloTrx.carrierCompany : siloTrx.carrierCompany.name)) || "-",
            chofer: (siloTrx.driver && (typeof siloTrx.driver === 'string' ? siloTrx.driver : siloTrx.driver.name)) || "-",
            patente: siloTrx.truckPlate || "-",
            kg: kg,
            bags: siloTrx.bags || 0,
            pesoBruto: siloTrx.truckGrossWeight || kg,
            comentarios: siloTrx.comment || "",
            relatedPallets: relatedPallets,
            originalData: siloTrxWrapper,
            type: "siloTrx",
            // FieldSite IDs for filtering
            originFieldSiteId: (siloTrx.fieldSite && siloTrx.fieldSite.id) || null,
            destinationFieldSiteId: null // Silos don't have destination fieldSite
          };
          movements.push(movement);
        });
      }

      // Transform palletTransactions (pallet movements - determine operation based on fieldSite comparison)
      if (response.palletTransactions && Array.isArray(response.palletTransactions)) {
        response.palletTransactions.forEach(palletTrx => {
          const pallet = palletTrx.pallet;
          const movement = {
            fecha: palletTrx.date || palletTrx.createdDate || null,
            operacion: this.determinePalletTrxOperation(palletTrx),
            estado: pallet ? this.mapPalletStatusToOperation(pallet.status) : "-",
            cultivoVariedad: pallet ? this.getCultivoVariedadFromItems(pallet) : "-",
            brand: pallet ? this.getBrandFromItems(pallet) : "-",
            campoOrigen: (palletTrx.fieldSiteOrigin && palletTrx.fieldSiteOrigin.name) || this.getFieldName((pallet && pallet.field) || palletTrx.field) || "-",
            plantaOrigen: this.getPlantName(palletTrx.originPlant || palletTrx.origin),
            plantaDestino: (palletTrx.fieldSiteDestination && palletTrx.fieldSiteDestination.name) || this.getPlantName(palletTrx.destinationPlant || palletTrx.destination) || "-",
            lote: pallet ? this.getLoteFromItems(pallet) : "-",
            pallet: (pallet && pallet.id) || palletTrx.palletId || "-",
            etiqueta: (pallet && pallet.label && pallet.label.id) || palletTrx.labelId || "-",
            transportista: this.getTransportista(palletTrx),
            chofer: this.getChofer(palletTrx),
            patente: this.getPatente(palletTrx),
            kg: palletTrx.kg || (pallet && pallet.kg) || palletTrx.quantity || 0,
            bags: palletTrx.bags || (pallet && pallet.bags) || 0,
            pesoBruto: palletTrx.grossWeight || palletTrx.kg || 0,
            comentarios: palletTrx.comments || palletTrx.observations || "",
            originalData: palletTrx,
            type: "palletTrx",
            // FieldSite IDs for filtering
            originFieldSiteId: (palletTrx.fieldSiteOrigin && palletTrx.fieldSiteOrigin.id) || null,
            destinationFieldSiteId: (palletTrx.fieldSiteDestination && palletTrx.fieldSiteDestination.id) || null
          };
          movements.push(movement);
        });
      }

      // Transform Pallets (individual pallets)
      if (response.pallets && Array.isArray(response.pallets)) {
        response.pallets.forEach(pallet => {
          const movement = {
            // Prefer the backend 'creationDate' field when present
            fecha: pallet.creationDate || pallet.date || pallet.createdDate || pallet.createdAt || null,
            operacion: this.mapPalletOperation(pallet),
            estado: this.mapPalletStatusToOperation(pallet.status),
            cultivoVariedad: this.getCultivoVariedadFromItems(pallet),
            brand: this.getBrandFromItems(pallet),
            campoOrigen: (pallet.fieldSite && pallet.fieldSite.name) || this.getFieldName(pallet.field) || "-",
            plantaOrigen: this.getPlantName(pallet.originPlant || pallet.plant),
            plantaDestino: this.getPlantName(pallet.destinationPlant),
            lote: this.getLoteFromItems(pallet),
            pallet: pallet.id || pallet.palletNumber || "-",
            etiqueta: (pallet.label && pallet.label.id) || pallet.labelId || "-",
            transportista: this.getTransportista(pallet),
            chofer: this.getChofer(pallet),
            patente: this.getPatente(pallet),
            kg: pallet.kg || pallet.weight || 0,
            bags: pallet.bags || pallet.numberOfBags || 0,
            pesoBruto: pallet.grossWeight || pallet.kg || 0,
            comentarios: pallet.comments || pallet.observations || "",
            originalData: pallet,
            type: "pallet",
            // FieldSite IDs for filtering
            originFieldSiteId: (pallet.fieldSite && pallet.fieldSite.id) || null,
            destinationFieldSiteId: null // Individual pallets don't have destination fieldSite
          };
          movements.push(movement);
        });
      }

      // Transform loadingOrders (loading/dispatch orders)
      if (response.loadingOrders && Array.isArray(response.loadingOrders)) {
        response.loadingOrders.forEach(loadingOrder => {
          // Calculate total KG from all pallets in the order
          const totalKg = loadingOrder.pallets 
            ? loadingOrder.pallets.reduce((sum, p) => sum + (p.netWeight || p.kg || 0), 0) 
            : 0;
          const totalBags = loadingOrder.pallets 
            ? loadingOrder.pallets.reduce((sum, p) => sum + (p.bagsNumber || p.bags || 0), 0) 
            : 0;

          const movement = {
            fecha: loadingOrder.dispatchDate || loadingOrder.creationDate || null,
            operacion: this.mapLoadingOrderOperation(loadingOrder),
            estado: this.mapLoadingOrderStatus(loadingOrder.status),
            cultivoVariedad: this.getCultivoVariedadFromLoadingOrder(loadingOrder),
            brand: this.getBrandFromLoadingOrder(loadingOrder),
            campoOrigen: this.getFieldName(loadingOrder.fieldSite) || "-",
            plantaOrigen: "-",
            plantaDestino: loadingOrder.destination || "-",
            lote: this.getLoteFromLoadingOrder(loadingOrder),
            pallet: loadingOrder.pallets ? loadingOrder.pallets.map(p => p.id).join(", ") : "-",
            etiqueta: "-",
            transportista: (loadingOrder.carrierCompany && loadingOrder.carrierCompany.name) || "-",
            chofer: loadingOrder.driverName || "-",
            patente: loadingOrder.truckPlate || "-",
            kg: totalKg,
            bags: totalBags,
            pesoBruto: totalKg,
            comentarios: loadingOrder.observations || loadingOrder.container || "",
            container: loadingOrder.container || "-",
            vessel: loadingOrder.vessel || "-",
            customer: (loadingOrder.customer && loadingOrder.customer.name) || "-",
            originalData: loadingOrder,
            type: "loadingOrder",
            // FieldSite IDs for filtering
            originFieldSiteId: (loadingOrder.fieldSite && loadingOrder.fieldSite.id) || null,
            destinationFieldSiteId: null // Loading orders don't have destination fieldSite as an entity
          };
          movements.push(movement);
        });
      }

      this.allMovementsList = movements;

      if (movements.length === 0) {
        this.$message.info(this.i18nValues['noResultsFound'] || "No se encontraron movimientos de stock con los filtros seleccionados");
      }

      this.applyFilters(preservePage);
    },

    applyFilters(preservePage) {
      let filtered = [...this.allMovementsList];

      if (this.filter.search) {
        const searchLower = this.filter.search.toLowerCase();
        filtered = filtered.filter(m => {
          return (
            (m.lote && m.lote.toString().toLowerCase().includes(searchLower)) ||
            (m.pallet && m.pallet.toString().toLowerCase().includes(searchLower)) ||
            (m.etiqueta && m.etiqueta.toString().toLowerCase().includes(searchLower)) ||
            (m.transportista && m.transportista.toLowerCase().includes(searchLower)) ||
            (m.chofer && m.chofer.toLowerCase().includes(searchLower)) ||
            (m.patente && m.patente.toLowerCase().includes(searchLower)) ||
            (m.cultivoVariedad && m.cultivoVariedad.toLowerCase().includes(searchLower))
          );
        });
      }

      if (this.filter.operationType) {
        filtered = filtered.filter(m => {
          const opLower = m.operacion.toLowerCase();
          return opLower === this.filter.operationType.toLowerCase();
        });
      }

      if (this.filter.stockStatus) {
        filtered = filtered.filter(m => {
          const statusLower = m.estado.toLowerCase().replace(/\s+/g, '_');
          return statusLower === this.filter.stockStatus.toLowerCase();
        });
      }

      // Apply sort
      if (this.sortProp && this.sortOrder) {
        const dir = this.sortOrder === "descending" ? -1 : 1;
        filtered.sort((a, b) => {
          const aVal = this.getNestedValue(a, this.sortProp);
          const bVal = this.getNestedValue(b, this.sortProp);
          if (aVal == null && bVal == null) return 0;
          if (aVal == null) return 1;
          if (bVal == null) return -1;
          return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
        });
      } else {
        // Default: date descending
        filtered.sort((a, b) => {
          const dateA = a.fecha ? new Date(a.fecha) : new Date(0);
          const dateB = b.fecha ? new Date(b.fecha) : new Date(0);
          return dateB - dateA;
        });
      }

      this.movementsList = filtered;
      if (!preservePage) this.initialPage = 1;
      this.syncRouteFromState();
      this.$nextTick(() => {
        const page = preservePage ? (this.initialPage || 1) : 1;
        this.initialPage = page;
      });
    },

    // Helper methods to extract data from nested objects
    getCultivoVariedad(product) {
      if (!product) return "-";
      if (product.cultivoVariedad) return product.cultivoVariedad;
      if (product.crop && product.variety) return `${product.crop} ${product.variety}`;
      if (product.cropType && product.variety) return `${product.cropType} ${product.variety}`;
      if (product.name) return product.name;
      if (product.code) return product.code;
      return "-";
    },

    getBrand(product) {
      if (!product) return "-";
      return product.brand || product.brandName || "-";
    },

    // Extract cultivoVariedad from Pallet items (handles single and multiple items)
    getCultivoVariedadFromItems(pallet) {
      if (!pallet || !pallet.items || !Array.isArray(pallet.items) || pallet.items.length === 0) {
        return "-";
      }
      
      const uniqueValues = new Set();
      pallet.items.forEach(item => {
        if (!item) return;
        
        let value = "-";
        
        // First try to get from product
        if (item.product) {
          value = this.getCultivoVariedad(item.product);
        }
        
        // If product is null or empty, try to get from item directly
        if (value === "-") {
          if (item.cropType) {
            // Try to build a meaningful string from cropType and other fields
            const cropType = item.cropType;
            const variety = item.variety || "";
            value = variety ? `${cropType} ${variety}` : cropType;
          } else if (item.batchPrefix) {
            value = item.batchPrefix;
          }
        }
        
        if (value !== "-") {
          uniqueValues.add(value);
        }
      });
      
      return uniqueValues.size > 0 ? Array.from(uniqueValues).join(", ") : "-";
    },

    // Extract brand from Pallet items (handles single and multiple items)
    getBrandFromItems(pallet) {
      if (!pallet || !pallet.items || !Array.isArray(pallet.items) || pallet.items.length === 0) {
        return "-";
      }
      
      const uniqueValues = new Set();
      pallet.items.forEach(item => {
        if (!item) return;
        
        let value = "-";
        
        // First try to get from product
        if (item.product) {
          value = this.getBrand(item.product);
        }
        
        // If product is null or empty, try to get from item directly
        if (value === "-") {
          if (item.brand) {
            value = item.brand;
          } else if (item.brandName) {
            value = item.brandName;
          } else if (item.batchPrefix) {
            // Use batchPrefix as fallback for brand
            value = item.batchPrefix;
          }
        }
        
        if (value !== "-") {
          uniqueValues.add(value);
        }
      });
      
      return uniqueValues.size > 0 ? Array.from(uniqueValues).join(", ") : "-";
    },

    // Extract lote/batch from Pallet items (handles single and multiple items)
    getLoteFromItems(pallet) {
      if (!pallet || !pallet.items || !Array.isArray(pallet.items) || pallet.items.length === 0) {
        return "-";
      }
      
      const uniqueValues = new Set();
      pallet.items.forEach(item => {
        if (!item) return;
        
        let value = "-";
        
        // Try to get batch from item (without prefix)
        if (item.batch) {
          value = item.batch.toString();
        } else if (item.lot) {
          value = item.lot;
        } else if (item.lotNumber) {
          value = item.lotNumber;
        }
        
        if (value !== "-") {
          uniqueValues.add(value);
        }
      });
      
      return uniqueValues.size > 0 ? Array.from(uniqueValues).join(", ") : "-";
    },

    getFieldName(field) {
      if (!field) return "-";
      return field.name || field.code || "-";
    },

    getPlantName(plant) {
      if (!plant) return "-";
      if (Array.isArray(plant) && plant.length > 0) {
        return plant.map(p => p.name || p.code || "").join(", ") || "-";
      }
      return plant.name || plant.code || "-";
    },

    getLote(fieldLot) {
      if (!fieldLot) return "-";
      return fieldLot.lot || fieldLot.lotNumber || fieldLot.id || "-";
    },

    getTransportista(entity) {
      if (!entity) return "-";
      
      // Check for loading order carrier company first
      if (entity.loadingOrder && entity.loadingOrder.carrierCompany) {
        // carrierCompany might be an object with name property or a string
        return typeof entity.loadingOrder.carrierCompany === 'string' 
          ? entity.loadingOrder.carrierCompany 
          : (entity.loadingOrder.carrierCompany.name || entity.loadingOrder.carrierCompany);
      }
      
      return (entity.carrier && entity.carrier.name) || entity.transportista || entity.carrierName || "-";
    },

    getChofer(entity) {
      if (!entity) return "-";
      
      // Check for loading order driver first
      if (entity.loadingOrder && entity.loadingOrder.driver) {
        return entity.loadingOrder.driver.name || entity.loadingOrder.driver;
      }
      
      return (entity.driver && entity.driver.name) || entity.chofer || entity.driverName || "-";
    },

    getPatente(entity) {
      if (!entity) return "-";
      
      // Check for loading order truck plate first
      if (entity.loadingOrder && entity.loadingOrder.truckPlate) {
        return entity.loadingOrder.truckPlate;
      }
      
      return entity.truckPlate || entity.patente || entity.licensePlate || "-";
    },

    mapSiloOperation(operation) {
      // Map silo operation using i18n values
      const operationMap = {
        "add": this.i18nValues['seedIncome'] || "Ingreso de Semilla",
        "withdrawal": this.i18nValues['mpConsumption'] || "Consumo MP",
        "inTara": this.i18nValues['inTara'] || "Ingreso Camión"
      };
      return operationMap[operation] || operation || "-";
    },

    mapPalletStatusToOperation(status) {
      // Map pallet status to operation display using i18n values
      if (!status) return "-";
      const statusToOperation = {
        "available": this.i18nValues["available"] || "Disponible",
        "loaded": this.i18nValues["loaded"] || "Cargado",
        "forLoading": this.i18nValues["forLoading"] || "Para Cargar",
        "dispatched": this.i18nValues["sent"] || "Despachado",
        "onHold": this.i18nValues["onHold"] || "En Espera",
        "discarded": this.i18nValues["discarded"] || "Descartado",
        "grainPort": this.i18nValues["grainPort"] || "Puerto Grano",
        "grainConsumption": this.i18nValues["grainConsumption"] || "Consumo Grano",
        "erased": this.i18nValues["erased"] || "Eliminado"
      };
      return statusToOperation[status] || status;
    },

    mapSiloTrxStatus(siloTrx) {
      // Map silo transaction status to display status using i18n
      if (siloTrx.status) {
        const statusMap = {
          "available": this.i18nValues['available'] || "Disponible",
          "loaded": this.i18nValues['loaded'] || "Cargado",
          "in_transit": this.i18nValues['inTransit'] || "En Tránsito",
          "dispatched": this.i18nValues['sent'] || "Despachado",
          "excess": this.i18nValues['excess'] || "Excedente",
          "finalized": this.i18nValues['finalized'] || "Finalizado",
          "open": this.i18nValues['open'] || "Abierto"
        };
        return statusMap[siloTrx.status.toLowerCase()] || siloTrx.status;
      }
      return this.i18nValues['available'] || "Disponible"; // Default for silo entries
    },

    determinePalletTrxOperation(palletTrx) {
      // Determine operation based on fieldSite comparison with global fieldSite
      const currentFieldSiteId = this.globalFieldSite ? this.globalFieldSite.id : null;
      const originId = palletTrx.fieldSiteOrigin ? palletTrx.fieldSiteOrigin.id : null;
      const destinationId = palletTrx.fieldSiteDestination ? palletTrx.fieldSiteDestination.id : null;
      
      const recibido = this.i18nValues['received'] || "Recibido";
      const enviado = this.i18nValues['sent'] || "Enviado";
      
      // If origin is different but destination matches current fieldSite → Receive
      if (originId !== currentFieldSiteId && destinationId === currentFieldSiteId) {
        return recibido;
      }
      
      // If origin matches current fieldSite but destination is different → Send
      if (originId === currentFieldSiteId && destinationId !== currentFieldSiteId) {
        return enviado;
      }
      
      // Fallback: use the operation field if available
      if (palletTrx.operation) {
        return this.mapPalletTrxOperationField(palletTrx.operation);
      }
      
      return "-";
    },

    mapPalletTrxOperationField(operation) {
      // Map palletTransaction.operation field to display text using i18n
      if (!operation) return "-";
      
      const operationMap = {
        "sent": this.i18nValues['sent'] || "Enviado",
        "received": this.i18nValues['received'] || "Recibido",
        "transfer": this.i18nValues['transfer'] || "Transferido",
        "created": this.i18nValues['created'] || "Creado",
        "loaded": this.i18nValues['loaded'] || "Cargado"
      };
      
      return operationMap[operation.toLowerCase()] || operation;
    },

    mapPalletTrxOperation(palletTrx) {
      // Determine operation type from pallet transaction using i18n (fallback method)
      const ingreso = this.i18nValues['entry'] || "Ingreso";
      const salida = this.i18nValues['exit'] || "Salida";
      const excedente = this.i18nValues['excess'] || "Excedente";
      
      if (palletTrx.operationType) {
        const opMap = {
          "input": ingreso,
          "output": salida,
          "transfer": salida,
          "excess": excedente
        };
        return opMap[palletTrx.operationType.toLowerCase()] || palletTrx.operationType;
      }
      // If destination exists, it's likely a "Salida"
      if (palletTrx.destinationPlant || palletTrx.destination) {
        return salida;
      }
      return ingreso;
    },

    mapPalletTrxStatus(palletTrx) {
      if (palletTrx.status) {
        const statusMap = {
          "available": "Disponible",
          "loaded": "Cargado",
          "in_transit": "En Tránsito",
          "dispatched": "Despachado",
          "excess": "Excedente"
        };
        return statusMap[palletTrx.status.toLowerCase()] || palletTrx.status;
      }
      // If destination exists, likely "En Tránsito" or "Despachado"
      if (palletTrx.destinationPlant || palletTrx.destination) {
        return "En Tránsito";
      }
      return "Disponible";
    },

    mapPalletOperation(pallet) {
      // Determine operation type for individual pallets using i18n
      const ingreso = this.i18nValues['entry'] || "Ingreso";
      const salida = this.i18nValues['exit'] || "Salida";
      
      // If destination exists, it's likely a "Salida"
      if (pallet.destinationPlant || pallet.destination) {
        return salida;
      }
      // If it's just in storage or has origin only
      return ingreso;
    },

    mapPalletStatus(pallet) {
      if (pallet.status) {
        const statusMap = {
          "available": "Disponible",
          "loaded": "Cargado",
          "in_transit": "En Tránsito",
          "dispatched": "Despachado",
          "delivered": "Despachado",
          "excess": "Excedente"
        };
        return statusMap[pallet.status.toLowerCase()] || pallet.status;
      }
      // Default for pallets in storage
      return "Disponible";
    },

    // Loading Order mapping methods
    mapLoadingOrderOperation(loadingOrder) {
      // Determine operation type for loading orders using i18n
      const despacho = this.i18nValues['dispatch'] || "Despacho";
      const enviado = this.i18nValues['sent'] || "Enviado";
      
      // Based on status, determine the operation
      if (loadingOrder.status === "dispatched") {
        return enviado;
      }
      return despacho;
    },

    mapLoadingOrderStatus(status) {
      if (!status) return "-";
      
      const statusMap = {
        "open": this.i18nValues['open'] || "Abierto",
        "forDispatch": this.i18nValues['forDispatch'] || "Para Despacho",
        "dispatched": this.i18nValues['dispatched'] || "Despachado",
        "inPort": this.i18nValues['inPort'] || "En Puerto",
        "arrivedToDestination": this.i18nValues['arrivedToDestination'] || "Llegado a Destino"
      };
      
      return statusMap[status] || status;
    },

    getCultivoVariedadFromLoadingOrder(loadingOrder) {
      if (!loadingOrder.pallets || !Array.isArray(loadingOrder.pallets) || loadingOrder.pallets.length === 0) {
        return "-";
      }
      
      const uniqueValues = new Set();
      loadingOrder.pallets.forEach(pallet => {
        if (pallet.items && Array.isArray(pallet.items)) {
          pallet.items.forEach(item => {
            if (item.product) {
              const cv = this.getCultivoVariedad(item.product);
              if (cv && cv !== "-") uniqueValues.add(cv);
            }
          });
        }
      });
      
      return uniqueValues.size > 0 ? Array.from(uniqueValues).join(", ") : "-";
    },

    getBrandFromLoadingOrder(loadingOrder) {
      if (!loadingOrder.pallets || !Array.isArray(loadingOrder.pallets) || loadingOrder.pallets.length === 0) {
        return "-";
      }
      
      const uniqueValues = new Set();
      loadingOrder.pallets.forEach(pallet => {
        if (pallet.items && Array.isArray(pallet.items)) {
          pallet.items.forEach(item => {
            if (item.product) {
              const brand = this.getBrand(item.product);
              if (brand && brand !== "-") uniqueValues.add(brand);
            }
          });
        }
      });
      
      return uniqueValues.size > 0 ? Array.from(uniqueValues).join(", ") : "-";
    },

    getLoteFromLoadingOrder(loadingOrder) {
      if (!loadingOrder.pallets || !Array.isArray(loadingOrder.pallets) || loadingOrder.pallets.length === 0) {
        return "-";
      }
      
      const uniqueValues = new Set();
      loadingOrder.pallets.forEach(pallet => {
        if (pallet.items && Array.isArray(pallet.items)) {
          pallet.items.forEach(item => {
            if (item.batch) uniqueValues.add(item.batch);
          });
        }
      });
      
      return uniqueValues.size > 0 ? Array.from(uniqueValues).join(", ") : "-";
    },

    getStatusType(estado) {
      const statusMap = {
        "Disponible": "", // Use custom green color (btn-primary)
        "Abierto": "", // Use custom green color (btn-primary)
        "Cargado": "", // Use custom blue color
        "En Tránsito": "warning",
        "Despachado": "",
        "Finalizado": "",
        "Excedente": "",
        "Para Despacho": "", // Loading order status
        "En Puerto": "warning", // Loading order status
        "Llegado a Destino": "", // Loading order status
      };
      return statusMap[estado] || "";
    },

    getStatusColor(estado) {
      const colorMap = {
        "Disponible": "#019e5a", // green (matches btn-primary)
        "Abierto": "#019e5a", // green (matches btn-primary)
        "Cargado": "#409eff", // blue
        "En Tránsito": "#e6a23c", // orange
        "Despachado": "#909399", // gray
        "Finalizado": "#909399", // gray
        "Excedente": "#9c27b0", // purple
        "Para Despacho": "#409eff", // blue - Loading order status
        "En Puerto": "#e6a23c", // orange - Loading order status
        "Llegado a Destino": "#67c23a", // green - Loading order status
      };
      return colorMap[estado] || "#909399";
    },

    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    formatNumber(num) {
      if (!num) return "0";
      return num.toLocaleString("es-ES");
    },

    viewDetails(row) {
      this.selectedMovement = row;
      this.modalVisible = true;
    },

    searchMovements() {
      this.requestGeneration++;
      this.initialPage = 1;
      this.loadStockHistory(false);
    },

    exportData() {
      if (!this.globalFieldSite || !this.globalFieldSite.id) {
        this.$message.warning(this.i18nValues['selectFieldSite'] || "Por favor seleccione un Campo de Origen");
        return;
      }

      const params = {
        fieldSiteId: this.globalFieldSite.id,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null,
        selectedLanguage: this.selectedLanguage || 'es'
      };

      // Add date filters if they exist
      if (this.filter.dateSince) {
        params.dateSince = new Date(this.filter.dateSince).getTime();
      }
      
      if (this.filter.dateUntil) {
        const dateUntil = new Date(this.filter.dateUntil);
        dateUntil.setHours(23, 59, 59, 999);
        params.dateUntil = dateUntil.getTime();
      }

      // Add origin fieldSite filter if selected
      if (this.filter.originFieldSiteId) {
        params.originFieldSiteId = this.filter.originFieldSiteId;
      }

      // Add destination fieldSite filter if selected
      if (this.filter.destinationFieldSiteId) {
        params.destinationFieldSiteId = this.filter.destinationFieldSiteId;
      }

      // Add product filter if selected
      if (this.filter.productId) {
        params.productId = this.filter.productId;
      }

      // Add loading order ID filter if entered
      if (this.filter.loadingOrderId) {
        params.loadingOrderId = this.filter.loadingOrderId;
      }

      this.$store
        .dispatch("stockHistory/exportExcelStockHistory", params)
        .then((res) => {
          const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          
          // Generate filename with current date
          const now = new Date();
          const dateStr = now.toISOString().split('T')[0];
          link.download = `stock_movement_history_${dateStr}.xlsx`;
          
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
          
          this.$message.success(this.i18nValues['success'] || "Exportación exitosa");
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error exporting stock history:", error);
          this.$message.error(this.i18nValues['error'] || "Error al exportar");
        });
    },

    onlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      if (this.sortProp === nextProp && this.sortOrder === nextOrder) return;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      const currentPage = this.initialPage || 1;
      this.initialPage = currentPage;
      this.applyFilters(true);
    },

    onPageChange(newPage) {
      this.initialPage = newPage;
      this.syncRouteFromState();
      // Server-side pagination: fetch the new page from backend
      this.loadStockHistory(true);
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.movementsSubList = evt.list;
      }
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    getNestedValue(obj, path) {
      if (!obj || !path) return null;
      return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : null), obj);
    },

    syncRouteFromState() {
      const q = {};
      if (this.filter.search) q.search = this.filter.search;
      if (this.filter.operationType) q.operationType = this.filter.operationType;
      if (this.filter.stockStatus) q.stockStatus = this.filter.stockStatus;
      if (this.filter.dateSince) {
        const ds = new Date(this.filter.dateSince);
        q.dateSince = `${ds.getFullYear()}-${String(ds.getMonth()+1).padStart(2,"0")}-${String(ds.getDate()).padStart(2,"0")}`;
      }
      if (this.filter.dateUntil) {
        const du = new Date(this.filter.dateUntil);
        q.dateUntil = `${du.getFullYear()}-${String(du.getMonth()+1).padStart(2,"0")}-${String(du.getDate()).padStart(2,"0")}`;
      }
      if (this.filter.originFieldSiteId) q.originFieldSiteId = String(this.filter.originFieldSiteId);
      if (this.filter.destinationFieldSiteId) q.destinationFieldSiteId = String(this.filter.destinationFieldSiteId);
      if (this.filter.productId) q.productId = String(this.filter.productId);
      if (this.filter.loadingOrderId) q.loadingOrderId = String(this.filter.loadingOrderId);
      const page = this.initialPage || 1;
      if (page && page > 1) q.page = String(page);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);
      const current = this.$route.query || {};
      const keys = new Set([...Object.keys(q), ...Object.keys(current)]);
      let same = true;
      for (const k of keys) {
        if (String(q[k] || "") !== String(current[k] || "")) { same = false; break; }
      }
      if (!same) {
        this.$router.replace({ query: q }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.main-content-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
}

.left-section {
  flex: 1;
  min-width: 0;
}

.right-section {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Filters */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}

.filters-row /deep/ .el-date-editor {
  width: 150px;
}

.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Summary Cards */
.summary-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.summary-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.summary-card {
  padding: 15px;
  border-radius: 6px;
  text-align: center;
  color: white;
}

.summary-card.ingresos {
  background-color: #019e5a;
}

.summary-card.salidas {
  background-color: #409eff;
}

.summary-card.excedentes {
  background-color: #9c27b0;
}

.summary-card.total-kg {
  background-color: #019e5a;
  grid-column: 1 / -1;
}

.summary-number {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.summary-label {
  font-size: 12px;
  opacity: 0.9;
}

/* Status Section */
.status-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}

.status-count {
  font-weight: 600;
  font-size: 14px;
}

/* Pagination */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

/* Fixed column styling to ensure proper overlap */
#StockMovementTable /deep/ .el-table__fixed-right {
  z-index: 3;
}

#StockMovementTable /deep/ .el-table__fixed-right .el-table__fixed-body-wrapper {
  background-color: #fff;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .main-content-wrapper {
    flex-direction: column;
  }

  .right-section {
    width: 100%;
  }

  .summary-cards {
    grid-template-columns: repeat(4, 1fr);
  }

  .summary-card.total-kg {
    grid-column: auto;
  }
}
</style>

